import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950">
      <div className="max-w-3xl mx-auto px-6 py-12" data-testid="terms-page">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mb-6">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">Terms of Service</h1>
        <p className="text-sm text-slate-400 mb-8">Last updated: March 2026</p>

        <div className="prose prose-slate dark:prose-invert prose-sm max-w-none space-y-6">
          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">1. Acceptance of Terms</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              By accessing or using Inspiro Tracker ("the Service"), operated by INPW Technologies Private Limited ("we", "us", or "our"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">2. Description of Service</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              Inspiro Tracker is a cloud-based time tracking and workforce management platform that provides time tracking, project management, team collaboration, reporting, invoicing, and related services for individuals and businesses.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">3. User Accounts</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to suspend or terminate accounts that violate these terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">4. Subscription & Billing</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              The Service offers free and paid subscription plans. Paid plans are billed on a per-seat, per-month or per-year basis. Prices are listed in Indian Rupees (INR). Payments are processed through Stripe and Razorpay. Subscriptions auto-renew unless cancelled before the billing period ends.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">5. Data Ownership</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              You retain full ownership of all data you enter into the Service. We do not claim any intellectual property rights over your content. You may export or delete your data at any time.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">6. Privacy</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              Your use of the Service is also governed by our <Link to="/privacy" className="text-blue-600 hover:text-blue-700 underline">Privacy Policy</Link>. By using the Service, you consent to our data practices as described therein.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">7. Acceptable Use</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              You agree not to misuse the Service, including but not limited to: attempting to gain unauthorized access, interfering with other users, uploading malicious content, or using the Service for any unlawful purpose.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">8. Limitation of Liability</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              To the maximum extent permitted by law, INPW Technologies Pvt Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">9. Changes to Terms</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              We may update these Terms from time to time. We will notify registered users of material changes via email or in-app notification. Continued use after changes constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">10. Governing Law</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Kolkata, West Bengal.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">11. Contact</h2>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:support@inspiroworks.com" className="text-blue-600 hover:text-blue-700 underline">support@inspiroworks.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
